import { render, staticRenderFns } from "./Остатки.vue?vue&type=template&id=286b7d0a&scoped=true"
import script from "./Остатки.vue?vue&type=script&lang=js"
export * from "./Остатки.vue?vue&type=script&lang=js"
import style0 from "./Остатки.vue?vue&type=style&index=0&id=286b7d0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286b7d0a",
  null
  
)

export default component.exports